// #region SPECIALTY columns definitions
import { EstensaColDef } from '../search-param.model';
import { TranslateService } from '@ngx-translate/core';
import { GridUtilitiesService } from '../../services/grid-utilities.service';
import { ExaminationWorklistDTO } from '@se/models';
import { IconType } from '@se/cp.common';

export function specialtyColumnDefs(translate: TranslateService, gridUtils: GridUtilitiesService): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'isExaminationLocked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'AssociatedSpecialty',
            headerName: '',
            valueGetter: (e) => e.data,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'associatedSpecialtyRenderer',
            cellRendererParams: (params: any) => {
                return params;
            },
        },
        {
            colId: 'AttachedDocuments',
            headerName: '',
            valueGetter: (e) => e.data.hasAttachedDocuments || e.data.hasAttachedDdevices,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'boolIconRenderer',
            cellRendererParams: (params: any) => {
                return {
                    estensa: {
                        iconType: IconType.AngularMaterial,
                        icon: 'file_present',
                        tooltip: getTooltip(params.data, translate)
                    }
                };
            }
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) => {
                const lastName = e.data.patient.surname ?? '';
                const firstName = e.data.patient.name ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            tooltipValueGetter: (e) => {
                const lastName = e.data.patient.surname ?? '';
                const firstName = e.data.patient.name ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            width: 220,
            minWidth: 220,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow', color: 'black' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red', color: 'black' };
                return null;
            },
        },
        {
            colId: '1',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'patient.birthDate',
            width: 180,
            minWidth: 180,
            valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            comparator: gridUtils.dateComparator,
        },
        {
            headerName: translate.instant('ExamDate'),
            headerTooltip: translate.instant('ExamDate'),
            field: 'examinationDate',
            colId: '2',
            width: 150,
            minWidth: 150,
            sort: 'desc',
            valueFormatter: gridUtils.dateTimeFormatter('examinationDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
            tooltipValueGetter: (p) => p.valueFormatted,
        },
        {
            headerName: translate.instant('ReportDate'),
            headerTooltip: translate.instant('ReportDate'),
            field: 'reportDate',
            colId: '3',
            width: 150,
            minWidth: 150,
            valueFormatter: gridUtils.dateTimeFormatter('reportDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('ReferringPhysician'),
            headerTooltip: translate.instant('ReferringPhysician'),
            tooltipField: 'referringPhysician.fullName',
            field: 'referringPhysician.fullName',
            colId: '4',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('SecondReferringPhysician'),
            headerTooltip: translate.instant('SecondReferringPhysician'),
            tooltipField: 'secondReferringPhysician.fullName',
            field: 'secondReferringPhysician.fullName',
            colId: '5',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('ReferringPhysicians'),
            headerTooltip: translate.instant('ReferringPhysicians'),
            tooltipField: 'referringPhysicianFullNameList',
            field: 'referringPhysicianFullNameList',
            colId: '6',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('ExamNumber'),
            headerTooltip: translate.instant('ExamNumber'),
            tooltipField: 'examNumber',
            field: 'examNumber',
            colId: '7',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            tooltipField: 'exam.description',
            field: 'exam.description',
            colId: '8',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            tooltipField: 'businessUnit.description',
            field: 'businessUnit.description',
            colId: '9',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '10',
            headerName: translate.instant('ReportingDeadline'),
            headerTooltip: translate.instant('ReportingDeadline'),
            tooltipField: 'reportingDeadline',
            field: 'reportingDeadline',
            width: 180,
            minWidth: 180,
        },
        {
            headerName: translate.instant('Status'),
            headerTooltip: translate.instant('Status'),
            tooltipField: 'status',
            field: 'status',
            colId: '11',
            width: 80,
            minWidth: 80,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Severity'),
            headerTooltip: translate.instant('Severity'),
            tooltipField: 'severity.description',
            field: 'severity.description',
            cellStyle: (params) => ({
                color:
                    params.data.severity?.color?.toLocaleLowerCase() == 'white'
                        ? 'black'
                        : params.data.severity?.color?.toLocaleLowerCase(),
            }),
            colId: '12',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('AIData_score'),
            headerTooltip: translate.instant('AIData_score'),
            tooltipField: 'aiData.score',
            field: 'aiData.score',
            colId: '13',
            width: 100,
            minWidth: 100,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Provenance'),
            headerTooltip: translate.instant('Provenance'),
            tooltipField: 'provenance.description',
            field: 'provenance.description',
            colId: '14',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('GroupProvenance'),
            headerTooltip: translate.instant('GroupProvenance'),
            tooltipField: 'provenance.groupProvenance.description',
            field: 'provenance.groupProvenance.description',
            colId: '15',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '16',
            headerName: translate.instant('PatientId'),
            headerTooltip: translate.instant('PatientId'),
            tooltipField: 'patient.patientId',
            field: 'patient.patientId',
            width: 190,
            minWidth: 190,
        },
        {
            headerName: translate.instant('OtherPatientId'),
            headerTooltip: translate.instant('OtherPatientId'),
            tooltipField: 'patient.otherPatientId',
            field: 'patient.otherPatientId',
            colId: '17',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '18',
            headerName: translate.instant('Sex'),
            headerTooltip: translate.instant('Sex'),
            tooltipField: 'patient.sex',
            field: 'patient.sexCode',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '19',
            headerName: translate.instant('Equipment'),
            headerTooltip: translate.instant('Equipment'),
            tooltipField: 'equipment.description',
            field: 'equipment.description',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '20',
            headerName: translate.instant('AdmissionNumber'),
            headerTooltip: translate.instant('AdmissionNumber'),
            field: 'admissionNumber',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '21',
            headerName: translate.instant('ExternalAdmissionNumber'),
            headerTooltip: translate.instant('ExternalAdmissionNumber'),
            tooltipField: 'externalAdmissionNumber',
            field: 'externalAdmissionNumber',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '22',
            headerName: translate.instant('TicketOk'),
            headerTooltip: translate.instant('TicketOk'),
            field: 'ticket',
            width: 80,
            minWidth: 80,
        },
        {
            colId: '23',
            headerName: translate.instant('FolderNumber'),
            headerTooltip: translate.instant('FolderNumber'),
            field: 'folderNumber',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '24',
            headerName: translate.instant('Accession_Number'),
            headerTooltip: translate.instant('Accession_Number'),
            field: 'accessionNumber',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '25',
            headerName: translate.instant('Technician'),
            headerTooltip: translate.instant('Technician'),
            tooltipField: 'technician.fullName',
            field: 'technician.fullName',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '26',
            headerName: translate.instant('WebDelivery'),
            headerTooltip: translate.instant('WebDelivery'),
            field: 'publicationAuthorization',
            width: 80,
            minWidth: 80,
        },
        {
            colId: '27',
            headerName: translate.instant('Modality'),
            headerTooltip: translate.instant('Modality'),
            tooltipField: 'modality.description',
            field: 'modality.description',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '28',
            headerName: translate.instant('DeliveryLocation'),
            headerTooltip: translate.instant('DeliveryLocation'),
            tooltipField: 'deliveryLocation.description',
            field: 'deliveryLocation.description',
            width: 180,
            minWidth: 180,
        },
        {
            colId: '29',
            headerName: translate.instant('DeliveryDate'),
            headerTooltip: translate.instant('DeliveryDate'),
            tooltipField: 'deliveryDate',
            field: 'deliveryDate',
            valueFormatter: gridUtils.dateFormatter('deliveryDate'),
            width: 180,
            minWidth: 180,
        },
        {
            colId: '30',
            headerName: translate.instant('AIData_status'),
            headerTooltip: translate.instant('AIData_status'),
            tooltipField: 'aiData.status',
            field: 'aiData.status',
            width: 180,
            minWidth: 180,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '31',
            headerName: translate.instant('AIData_clinicalApp'),
            headerTooltip: translate.instant('AIData_clinicalApp'),
            tooltipField: 'aiData.clinicalApp',
            field: 'aiData.clinicalApp',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '32',
            headerName: translate.instant('ClinicalAlert'),
            field: 'clinicalAlert',
            headerTooltip: translate.instant('ClinicalAlert'),
            headerComponentParams: {
                template:
                    '<div><img src="assets/images/menu/WarningSign.png" style="height:18px;width:18px;"> </img></div>',
            },
            width: 32,
            minWidth: 32,
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '32px' },
            cellRenderer: (params: ExaminationWorklistDTO) =>
                params.clinicalAlert
                    ? '<div><img src="assets/images/menu/WarningSign.png" style="height:18px;width:18px;"> </img></div>'
                    : '<div></div>',
            tooltipValueGetter: (p) => p.value,
            sortable: false,
            context: { estensaDetails: { primary: false } },
            hide: true,
        },
        {
            colId: '33',
            headerName: translate.instant('MedicalOperator'),
            field: 'operator.fullName',
            headerTooltip: translate.instant('MedicalOperator'),
            width: 180,
            minWidth: 180,
            context: { estensaDetails: { primary: false } },
            hide: true,
        },
        {
            colId: '34',
            headerName: translate.instant('ReportSheets'),
            field: 'reportSheets',
            headerTooltip: translate.instant('ReportSheets'),
            valueGetter: (e) => {
                let description = e.data.reportSheets?.map(el => el.description).join(' - ');
                return description;
            },
            tooltipValueGetter: (e) => {
                let description = e.data.reportSheets?.map(el => el.description).join(' - ');
                return description;
            },
            width: 180,
            minWidth: 180,
            context: { estensaDetails: { primary: false } },
            hide: true,
        },
        {
            colId: '35',
            headerName: translate.instant('PerformedProcedures'),
            field: 'performedProcedures',
            headerTooltip: translate.instant('PerformedProcedures'),
            tooltipValueGetter: (p) => p.value,
            width: 180,
            minWidth: 180,
            context: { estensaDetails: { primary: false } },
            hide: true,
        }
    ];

    // #endregion
}

export function getTooltip(params: any, translate: TranslateService): string {
    if (params.hasAttachedDocuments && params.hasAttachedDdevices) {
        return translate.instant('DocumentsAndDevicesAttached');
    }
    else if (params.hasAttachedDocuments) {
        return translate.instant('AttachedDocuments');
    }
    else if (params.hasAttachedDdevices) {
        return translate.instant('AttachedDevices');
    } else {
        return '';
    }
}
